<template>
    <div class="f-user-center" v-if="list" id="user-center">
        <div class="f-user-center-head">
            <span class="fa fa-bell fa-lg"></span>
            <span class="f-user-center-head-title">社区消息中心</span>
            <div class="f-user-center-head-select" v-if="list.length">
                <span class="f-user-center-head-clear" @click="clearAll">清空</span>
                <span class="f-user-center-head-border">|</span>
                <span v-if="canReadAll" class="f-user-center-head-read" @click="readAll">标记已读</span>
                <span v-if="!canReadAll" class="f-user-center-head-read-not">标记已读</span>
            </div>
        </div>

        <div v-if="list.length === 0"
            class="f-user-center-empty">
            <div class="f-user-center-empty-tips">
                <img v-on:click.prevent.self
                    :src="noMessage"
                    alt="无消息"
                    class="f-user-center-empty-img">
                <div class="f-user-center-empty-word">
                    您还没有收到任何消息
                </div>
            </div>   
        </div>
        <div v-else>
            <note-list v-for="(item, index) in list"
                :key="index"
                :listitem="item"></note-list>
        </div>

        <div class="f-user-center-list-page">
            <page-component v-if="pageInfo.recordTotal > pageInfo.pageSize"
                class="f-user-center-list-page-form"
                :pageInfo="pageInfo"
            ></page-component>
            <load-more
                class="f-user-center-list-page-more"
                @load="load"
                :pullUpState="pageInfo.pageNo < pageInfo.pageTotal ? 2 : 3"
                selector-id="user-center">
            </load-more>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/views/user-center/user-center.less';
</style>

<script>
import {mapState} from 'vuex';
import NoteList from './components/NoteList.vue';
import Page from '@/views/components/page';
import LoadMore from '@/views/components/LoadMore.vue';

import {throttle} from '@/utils/debounceThrottle.js';
import {scrollToId} from '@/utils/decorate/scroll';

export default {
    data() {
        return {
            noMessage: require('../../assets/images/userCenter/empty-message.png')
        };
    },
    computed: {
        ...mapState({
            list: state => state.userCenter.list,
            pageInfo: state => state.userCenter.pageInfo,
            canReadAll: state => state.userCenter.canReadAll,
            isSwan: state => state.common.isSwan
        })
    },
    mounted() {
        let query;
        if (this.isSwan) {
            query = this.$route;
        }
        else {
            query = this.$route.query;
        }
        this.$store.dispatch('getUserCenterList', {query});
    },
    destroyed() {
        this.$store.commit('clearUserCenterData');
    },
    components: {
        'note-list': NoteList,
        'page-component': Page,
        'load-more': LoadMore
    },
    methods: {
        watchHandler(to, from) {
            // 统计pv
            _hmt.push(['_trackPageview', '/forum' + to.path]);

            this.$store.dispatch('getUserCenterList', {query: to.query})
                .then(() => {
                    if (to.query.pageNo && to.query.pageNo !== from.query.pageNo) {
                        scrollToId('app');
                    }
                });
        },
        swanWatch() {
            this.$store.dispatch('getUserCenterList', {query: {}});
        },
        clearAll: throttle(function () {
            this.$store.dispatch('clearList');
        }),
        readAll: throttle(function () {
            this.$store.dispatch('readList');
        }),
        load: throttle(function (type, isPageTurn) {
            if (type === 'more') {
                this.loadMore();
            }
            else {
                this.loadLess(isPageTurn);
            }
        }),
        loadMore() {
            let query;
            if (this.isSwan) {
                query = this.$route;
            }
            else {
                query = this.$route.query;
            }
            this.$store.dispatch('getUserCenterList', {query, loadMore: true});
        },
        loadLess(isPageTurn) {
            let name = this.$route.name;
            let query = Object.assign({}, this.$route.query);
            // 如果是翻页组件，获取当前数据的页码
            if (isPageTurn) {
                // 页码相同不触发 watch，手动请求接口
                if (+query.pageNo === +this.pageInfo.pageNo) {
                    this.$store.dispatch('getUserCenterList', {query, loadMore: false});
                    return;
                }
                query.pageNo = this.pageInfo.pageNo;
                this.$router.push({name, query});
            }
            // 如果是loadMore组件，数据从首页开始
            else {
                query.pageNo = 1;
                this.$store.dispatch('getUserCenterList', {query, loadMore: false});
            }
        }
    }
};
</script>